<!-- Floating Chat Button -->
@if (isAssistantEnabled && !isVisible) {
<button class="chat-fab" (click)="toggleChat()" aria-label="Open AI Assistant">
  <mat-icon>chat</mat-icon>
  @if (isOnline | async) {
  <div class="notification-badge"></div>
  }
</button>
}

<!-- Chat Container -->
@if (isAssistantEnabled && isVisible) {
<div class="chat-container" [class.visible]="isVisible" [class.expanded]="isExpanded">

  <!-- Header -->
  <div class="chat-header">
    <div class="assistant-info">
      <div class="avatar-container">
        <img [src]="assistantAvatar" alt="Assistant" class="avatar" (error)="onImageError($event)">
        <div class="status-dot" [class.online]="isOnline | async" [class.offline]="(isOnline | async) === false"></div>
      </div>
      <div class="assistant-text">
        <span class="name">{{ assistantName }}</span>
        <span class="status">{{ (isOnline | async) ? 'Online' : 'Offline' }}</span>
      </div>
    </div>
    <div class="header-actions">
      <button mat-icon-button (click)="expandChat()" matTooltip="Expand">
        <mat-icon>{{ isExpanded ? 'collapse_content' : 'expand_content' }}</mat-icon>
      </button>
      <button mat-icon-button (click)="clearChat()" matTooltip="Clear chat">
        <mat-icon>restart_alt</mat-icon>
      </button>
      <button mat-icon-button (click)="toggleChat()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Quick Actions -->
  @if (messages.length <= 1) {
  <div class="quick-actions">
    <span class="quick-title">Quick actions</span>
    <div class="quick-btns">
      @for (action of quickActions; track action.id) {
      <button mat-stroked-button (click)="handleQuickAction(action.id)" class="quick-btn">
        <mat-icon>{{ action.icon }}</mat-icon>{{ action.label }}
      </button>
      }
    </div>
  </div>
  }

  <!-- Messages -->
  <div #chatContent class="chat-messages">
    @for (message of messages; track trackByMessage($index, message)) {
    <div class="msg-row" [class.user]="message.isUser" [class.bot]="!message.isUser" [class.typing]="message.isTyping">
      @if (!message.isUser) {
      <div class="msg-avatar">
        @if (assistantAvatar) {
        <img [src]="assistantAvatar" alt="Amber" (error)="onImageError($event)">
        } @else {
        <mat-icon>smart_toy</mat-icon>
        }
      </div>
      }
      <div class="msg-body">
        <div class="msg-bubble">
          @if (message.isTyping) {
          <div class="typing-dots"><span></span><span></span><span></span></div>
          } @else {
          <span class="msg-text" [innerHTML]="formatMessage(message.message)"></span>
          }
        </div>
        <span class="msg-time">{{ formatTime(message.timestamp) }}</span>
      </div>
    </div>
    }
  </div>

  <!-- Offline Banner -->
  @if ((isOnline | async) === false) {
  <div class="offline-banner">
    <mat-icon>wifi_off</mat-icon> Assistant is offline — limited functionality
  </div>
  }

  <!-- Input -->
  <div class="chat-input">
    @if (attachedFiles.length > 0) {
    <div class="attachments">
      @for (file of attachedFiles; track $index) {
      <div class="file-tag">
        <mat-icon>{{ getFileIcon(file) }}</mat-icon>
        <span>{{ file.name }}</span>
        <button mat-icon-button (click)="removeAttachment($index)"><mat-icon>close</mat-icon></button>
      </div>
      }
    </div>
    }
    <div class="input-row">
      <input type="file" #fileInput (change)="onFileSelected($event)"
        accept="image/*,.pdf,.docx,.doc,.txt,.md,.mp3,.wav,.m4a,.ogg" multiple hidden>

      <button mat-icon-button (click)="fileInput.click()"
        [disabled]="isTyping || attachedFiles.length >= 10" class="attach-btn" matTooltip="Attach files">
        <mat-icon>attach_file</mat-icon>
      </button>

      <textarea #messageInput [(ngModel)]="currentMessage" rows="1"
        placeholder="Ask me anything..."
        maxlength="500"
        (keydown)="onKeyPress($event)"
        class="msg-input"></textarea>

      <button mat-icon-button color="primary" (click)="sendMessage()"
        [disabled]="(!currentMessage.trim() && attachedFiles.length === 0) || isTyping"
        class="send-btn" matTooltip="Send">
        @if (isTyping) {
        <mat-spinner diameter="20"></mat-spinner>
        } @else {
        <mat-icon>send</mat-icon>
        }
      </button>
    </div>
    @if (currentMessage.length > 400) {
    <div class="char-count">{{ currentMessage.length }}/500</div>
    }
  </div>
</div>
}

<!-- Backdrop -->
@if (isVisible && isExpanded) {
<div class="backdrop" (click)="expandChat()"></div>
}
